/*
 * Size calculator (sections/size-calculator.liquid).
 * Same rule as the live site:
 *   1. height picks the base size (cut-offs come from the section settings)
 *   2. lighter than the "low" weight -> one size down; heavier than "high" -> one size up
 */
const SIZES = ['XS', 'S', 'M', 'L', 'XL'];

class SizeCalculator extends HTMLElement {
  connectedCallback() {
    this.heights = this.dataset.heights.split(',').map(Number); // e.g. [160, 170, 180, 190]
    this.weightLow = Number(this.dataset.weightLow);
    this.weightHigh = Number(this.dataset.weightHigh);
    this.result = this.querySelector('[data-size-result]');

    this.querySelector('[data-size-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate(event.target);
    });
  }

  calculate(form) {
    const height = parseInt(form.height.value, 10);
    const weight = parseInt(form.weight.value, 10);
    const product = form.product.value;

    if (!height || !weight || !product) {
      this.result.textContent = 'please fill in all fields.';
      return;
    }

    // Base size from height: the first cut-off the height fits under, otherwise XL
    let index = this.heights.findIndex((maxHeight) => height <= maxHeight);
    if (index === -1) index = SIZES.length - 1;

    // Adjust one size for very light / heavy builds
    if (weight < this.weightLow) index = Math.max(0, index - 1);
    else if (weight > this.weightHigh) index = Math.min(SIZES.length - 1, index + 1);

    this.result.innerHTML = '';
    this.result.append(
      'based on your inputs, we recommend size ',
      Object.assign(document.createElement('strong'), { textContent: SIZES[index] }),
      ' for the ',
      Object.assign(document.createElement('strong'), { textContent: product }),
      '. please use this guide as a reference only.'
    );
  }
}

customElements.define('size-calculator', SizeCalculator);
